import i18n from 'i18next';
import { MM_HEADERS } from '../../constants/main';

export const getDefaultHeaders = (): Record<string, string> => {
    return {
        ...MM_HEADERS,
        'x-language': i18n.language || process.env.NEXT_PUBLIC_LANGUAGE,
    };
};
